import React, { useEffect, useState } from "react";
import { Col, Container, Row } from "react-bootstrap";
import { useParams } from "react-router-dom";
import EventDetailsPage from "../components/eventsGallery/EventDetailsPage";
import EventGalleryList from "../components/eventsGallery/EventGalleryList";
import API from "../config/axios";
import { api_paths } from "../config/api.paths";

const EventGallery = () => {
  const { eventId } = useParams();
  const [loading, setLoading] = useState(false);
  const [events, setEvents] = useState([]);

  useEffect(() => {
    const fetchEvent = async () => {
      try {
        setLoading(true);

        const response = await API.get(
          api_paths.member.EVENTS.EVENT_GALLERY_PAGE.GET_LIST
        );

        const data = response.data?.payload?.result?.data || null;
        // console.log("Event gallery data: ", data);

        setEvents(data);
      } catch (error) {
        console.error("Error fetching event gallery:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchEvent();
  }, []);

  if (eventId) {
    return <EventDetailsPage eventId={eventId} />;
  }

  return (
    <Container className="py-5">
      <Row className="mb-4">
        <Col lg={12}>
          <div className="rsvp-header text-center">
            <h1 className="inter-bold h1">Event Gallery</h1>
            <p>Capturing memories from our community events</p>
          </div>
        </Col>
      </Row>

      {!loading && events.length > 0 && (
        <EventGalleryList data={events}/>
      )}

      {/* <EventGalleryList /> */}
    </Container>
  );
};

export default EventGallery;
